var r={exports:{}};export{r as d};
//# sourceMappingURL=dayjs.min.js.map
